import {
  Component,
  OnInit,
  OnDestroy,
  AfterViewInit,
  ViewChild,
} from "@angular/core";
import { DatePipe, formatDate } from "@angular/common";
import {
  HttpClient,
  HttpHeaders,
  HttpEvent,
  HttpEventType,
  HttpResponse,
  HttpProgressEvent,
  HttpRequest,
} from "@angular/common/http";
import { forkJoin } from "rxjs";
import { AppConfig } from "../app.config";
import { FlashMessageComponent } from "../flash-message/flash-message.component";
import { FlashMessageService } from "../flash-message/flash-message.service";

@Component({
  selector: "app-file-copying",
  templateUrl: "./file-copying.component.html",
  styleUrls: ["./file-copying.component.css"],
  providers: [DatePipe],
})
export class FileCopyingComponent implements OnInit, AfterViewInit, OnDestroy {
  public files: string[];
  public fileStructure = {} as any;
  public fStrucArray;
  public copy = {} as any;
  public copyKeys = [];
  public cameras;
  public cams;
  public maxDate;
  public selectedCam;
  public selectedDate;
  public intervalTimer;
  public reviewing = false;

  @ViewChild("fmDialog", { static: true })
  public fmDialog: FlashMessageComponent;

  constructor(
    private flashService: FlashMessageService,
    private http: HttpClient,
    private datePipe: DatePipe
  ) {
    this.maxDate = new Date(new Date().getTime() - 8.64e7);
    this.http
      .get(`${AppConfig.settings.playbackServerUrl2}cameraList`)
      .subscribe((x) => {
        this.cameras = x;
        this.cams = Object.keys(this.cameras).sort();
      });
  }

  ngOnInit(): void {
    this.flashService.register(this.fmDialog);
    this.listTheFiles();
  }

  ngAfterViewInit() {
    this.intervalTimer = setInterval(() => {
      this.listTheFiles();
    }, 60000);
  }

  ngOnDestroy() {
    if (this.intervalTimer) {
      clearInterval(this.intervalTimer);
    }
  }

  listTheFiles() {
    if (this.reviewing) return;
    var _this = this;
    var fStructure = {} as any;
    var url = "copying/api/1/list";
    var pattern = /^.*\/[0-9]{4}\/[0-9]{2}\/[0-9]{2}$/;
    this.http.get<any>(url).subscribe((x) => {
      this.files = x.files.filter((f) => pattern.test(f));
      this.files.forEach((f) => {
        var path = f.split("/");
        var host, year, month, day, ff;
        host = path[0];
        if (!fStructure[host]) fStructure[host] = { delete: false };
        ff = fStructure[host];
        year = path[1];
        if (!ff[year]) ff[year] = { delete: false };
        ff = ff[year];
        month = path[2];
        if (!ff[month]) ff[month] = { delete: false };
        ff = ff[month];
        day = path[3];
        if (!ff[day]) ff[day] = { delete: false };
      });
      this.fileStructure = fStructure;
      this.fStrucArray = Object.keys(this.fileStructure)
        .filter((s) => s != "delete")
        .sort((a, b) => {
          return _this.getCamName(a).localeCompare(_this.getCamName(b));
        })
        .map((h) => {
          var o = {
            host: h,
            name: _this.getCamName(h),
            expand: false,
            years: Object.keys(this.fileStructure[h])
              .filter((s) => s != "delete")
              .sort()
              .map((y) => {
                var o2 = {
                  name: y,
                  expand: false,
                  months: Object.keys(this.fileStructure[h][y])
                    .filter((s) => s != "delete")
                    .sort()
                    .map((m) => {
                      var o3 = {
                        name: m,
                        expand: false,
                        days: Object.keys(this.fileStructure[h][y][m])
                          .filter((s) => s != "delete")
                          .sort(),
                      };
                      return o3;
                    }),
                };
                return o2;
              }),
          };
          return o;
        });
    });
  }
  toggle(r) {
    r.expand = !r.expand;
    this.reviewing = true;
  }
  toggleDelete() {
    this.reviewing = true;
  }

  addToCopy() {
    if (this.selectedDate) {
      var d = new Date(this.selectedDate);
      var dString = this.datePipe.transform(d, "yyyy-MM-dd");
      if (!this.copy[this.selectedCam]) {
        this.copy[this.selectedCam] = dString;
        this.copyKeys = Object.keys(this.copy);
      } else {
        if (!this.copy[this.selectedCam].includes(dString))
          this.copy[this.selectedCam] += "," + dString;
      }
    }
  }

  copyFiles() {
    var _this = this;
    forkJoin(
      _this.copyKeys.map((c) => {
        var body = {
          host: _this.getCamHost(c),
          date: _this.copy[c],
        };
        return _this.http.put<any>("copying/api/1/copy", body);
      })
    ).subscribe(
      (res) => {
        _this.copy = {} as any;
        _this.copyKeys = [];
        this.reviewing = false;
        _this.listTheFiles();
      },
      (err) => {
        if (504 == err.status) {
          _this.copy = {} as any;
          _this.copyKeys = [];
          this.reviewing = false;
          _this.listTheFiles();
        } else
          _this.flashService
            .showThis(
              "Error Copying Files To Storage",
              err.statusText +
                " : " +
                (err.error.details ? err.error.details : err.error),
              false
            )
            .then((res) => {
              _this.flashService.resetModal();
            })
            .catch((error) => {
              _this.flashService.resetModal();
            });
      }
    );
  }

  getCamHost(cam) {
    return this.cameras[cam].host;
  }
  getCamName(host) {
    var res;
    var re = RegExp("^" + host + "$");
    res = Object.keys(this.cameras).find((c) => this.cameras[c].host.match(re));
    return res ? res : "ZZ - Undefined - ZZ";
  }

  deleteStuff() {
    var _this = this;
    this.http.put<any>("copying/api/1/delete", this.fileStructure).subscribe(
      (data) => {
        this.reviewing = false;
        _this.listTheFiles();
      },
      (err) => {
        this.reviewing = false;
        _this.listTheFiles();
      }
    );
  }
}
